import React, { FC } from 'react';
import BorderGradientCircle from '@/components/BorderGradientCircle/BorderGradientCircle';
import useIsMobileView from '@/hooks/useIsMobileView';

interface MultipleTablesPreviewProps {
  tablesCount: number;
  onClickSeeDetails: () => void;
}
const MultipleTablesPreview: FC<MultipleTablesPreviewProps> = ({ tablesCount, onClickSeeDetails }) => {
  const isMobileView = useIsMobileView();
  return (
    <div className="ml-[-2px] flex w-full items-center justify-center gap-4 md:justify-start">
      {!isMobileView && (
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-phenom-border-glow p-2.5">
          <BorderGradientCircle>
            <span className="text-xs font-semibold text-ph-purple">{tablesCount}</span>
          </BorderGradientCircle>
        </div>
      )}
      <div className={'flex flex-col'}>
        <span className="text-sm font-semibold text-white md:text-base">{tablesCount} tables</span>
        <span
          onClick={onClickSeeDetails}
          className="cursor-pointer text-sm text-xs font-semibold text-ph-purple md:text-base"
        >
          See details
        </span>
      </div>
    </div>
  );
};

export default MultipleTablesPreview;
